import React from 'react';
import { useMassEditModalsState, MassEditModalsContext } from './use-mass-edit-modals';

export const MassEditModalsProvider = ({ children }) => {
    const massEditModalsState = useMassEditModalsState();
    const { modalComponent: ModalComponent } = massEditModalsState;
    const renderModalComponent = () => !ModalComponent ? null : (
        <ModalComponent />
    );
    return (
        <MassEditModalsContext.Provider value={massEditModalsState}>
            {children}
            {renderModalComponent()}
        </MassEditModalsContext.Provider>
    );
};

